<div *ngIf="languaje === 'en'">
  <li class="pill" [ngClass]="{'active': is_active}" (click)="showContent()">
    <a class="icon-Shape-5">Benefits Scope</a>
  </li>

  <a class="icon-Shape-5 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Benefits
    Scope</a>
  <div class="tab-pane active" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">

    <h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">BENEFITS SCOPE</h2>

    <div class="container" [ngClass]="{'show': show_description1}">
      <p><strong>Eligibility</strong> - The following individuals are eligible for Benefits under this cover for up to
        120 days maximum per Trip:</p>
      <ul class="romano">
        <li>Individuals who hold valid extensions of Corporate or Business cards issued by <strong>Miles</strong> and
          have joined the <strong>Miles</strong> program when a loss occurs</li>
        <li>
          <p>Individual cardholders who have active cards and have joined the <strong>Miles</strong> program when a loss
            occurs; and the following:</p>
          <ul class="romano">
            <li>Their Eligible Spouse; and</li>
            <li>Their Dependent Child(ren) who are at least 14 days old; and</li>
            <li>Their Dependent Parents each of which is a <strong>Covered Person</strong>.</li>
          </ul>
        </li>
      </ul>
      <p>
        <strong>Usership Period</strong> - This cover becomes effective and terminates on the dates and at the times
        advised to the Member. This cover can be renewed for subsequent periods
        subject to agreement of <strong>Miles</strong>. This cover can be cancelled by the Member by giving not less
        than 60 days advance notice to <strong>Miles</strong> at the start of this Evidence of Cover. This cover can be
        cancelled by <strong>Miles</strong> by giving not less than 60 days advance notice to the <strong>User</strong>.
        In the event this cover is cancelled by either party, or is not renewed at any anniversary, coverage regarding
        <strong>Miles, Covered Persons</strong> shall terminate as of the date of cancellation or non-renewal.
        Notwithstanding the forgoing, <strong>Miles</strong> may cancel
        this cover at any time in accordance with Part IV, General Conditions and Conditions
        Precedent, of this cover.
      </p>
      <p>
        <strong>Effective Date of Coverage for a Covered Person</strong>- Coverage becomes effective on the moment the
        <strong>Covered Person</strong> departs from their <strong>Home Country</strong>.
      </p>
      <p>
        <strong>Termination Date of Coverage for a Covered Person</strong>- Coverage ends on the earliest of the
        following:
      </p>
      <ul class="number">
        <li>The moment the <strong>Covered Person</strong> returns to their Home Country, or</li>
        <li>11:59 pm on the 120th day following the date the <strong>Covered Person</strong> departs his or her Home
          Country, or</li>
        <li>11:59 pm on the last day of the Usership Period, or</li>
        <li>The date the <strong>Covered Person</strong> no longer meets the Eligibility requirements stated herein.
        </li>
      </ul>
    </div>
  </div>
</div>


<!--ESPAÑOL-->
<!--ESPAÑOL-->


<div *ngIf="languaje === 'es'">
  <li class="pill" [ngClass]="{'active': is_active}" (click)="showContent()">
    <a class="icon-Shape-5">Disposiciones de Cobertura</a>
  </li>

  <a class="icon-Shape-5 pill-mobile" [ngClass]="{'active': show_mobile}" (click)="showMobileContent()">Disposiciones de
    Cobertura</a>
  <div class="tab-pane active" *ngIf="show_content || show_mobile" [ngClass]="{'show': show_mobile}">

    <h2 class="titulo-intro" (click)="toggleClass('1')" [ngClass]="{'open': show_description1}">DISPOSICIONES DE
      COBERTURA</h2>

    <div class="container" [ngClass]="{'show': show_description1}">
      <p><strong>ELEGIBILIDAD</strong></p>
      <p>Las siguientes personas son elegibles para los <strong>Beneficios</strong> estipulados en esta cobertura por un
        m&aacute;ximo de 120 d&iacute;as por <strong>Viaje</strong>:</p>
      <ul class="letter">
        <li>poseedores de extensiones v&aacute;lidas de las tarjetas Corporativa o Empresarial emitidas por
          <strong>Miles Care by Novae </strong>que pertenezcan al programa <strong>Miles Care by Novae </strong>cuando
          ocurra un siniestro;</li>
        <li>titulares individuales con tarjetas activas que pertenezcan al programa <strong>Miles Care by Novae
          </strong>cuando ocurra un siniestro; y las siguientes personas:
          <ul class="romano">
            <li>su <strong>C&oacute;nyuge Elegible</strong>; y</li>
            <li>sus <strong>Hijos Dependientes </strong>con al menos 14 d&iacute;as de edad; y</li>
            <li>sus <strong>Padres Dependientes</strong>; cada uno de los cuales se considerar&aacute; una
              <strong>Persona Elegible</strong>.</li>
          </ul>
        </li>
      </ul>

      <p><strong>Per&iacute;odo de Cobertura - </strong>Esta cobertura entra en vigencia y termina en las fechas y horas
        informadas a la <strong>Persona Cubierta</strong> por correo electr&oacute;nico. Esta cobertura puede ser
        renovada por per&iacute;odos subsiguientes sujeto al acuerdo de <strong>Miles Care by Novae</strong>. La
        <strong>Persona Cubierta</strong> puede cancelar esta cobertura mediante notificaci&oacute;n por escrito con no
        menos de 60 d&iacute;as de anticipaci&oacute;n a <strong>Miles Care by Novae </strong>al inicio de vigencia del
        siguiente periodo de Cobertura. <strong>Miles Care by Novae </strong>podr&aacute; cancelar esta cobertura
        mediante notificaci&oacute;n por escrito remitida a la <strong>Persona Cubierta</strong> con no menos de 60
        d&iacute;as de anticipaci&oacute;n. En caso de que esta cobertura sea cancelada por cualquiera de las partes, o
        no sea renovada en ning&uacute;n aniversario, dejar&aacute; de tener validez con respecto a las <strong>Personas
          Cubiertas</strong> de <strong>Miles Care by Novae </strong>a partir de la fecha de cancelaci&oacute;n o falta
        de renovaci&oacute;n. Sin perjuicio de lo anterior, <strong>Miles Care by Novae</strong> podr&aacute; cancelar
        esta cobertura en cualquier momento de conformidad con la Parte II, Condiciones Generales y Suspensivas.</p>
      <p><strong>FECHA DE VIGENCIA DE LA COBERTURA PARA UNA PERSONA CUBIERTA&nbsp;</strong></p>
      <p>La cobertura entra en vigor en el momento en que la <strong>Persona Cubierta</strong> abandona su
        <strong>Pa&iacute;s de Origen</strong>.</p>
      <p><strong>FECHA DE FINALIZACI&Oacute;N DE COBERTURA DE UNA PERSONA CUBIERTA</strong></p>
      <p>La cobertura termina en la primera de las siguientes fechas:</p>
      <ul class="number">
        <li>el d&iacute;a en que la <strong>Persona Cubierta </strong>regresa su <strong>Pa&iacute;s de Origen</strong>;
          o</li>
        <li>a las 11:59 p. m. del d&iacute;a 120 posterior a la fecha en que la <strong>Persona Cubierta</strong>
          abandona su <strong>Pa&iacute;s de Origen</strong>; o</li>
        <li>a las 11:59 p. m. del &uacute;ltimo d&iacute;a del <strong>Per&iacute;odo de Cobertura</strong>; o</li>
        <li>el d&iacute;a en que la <strong>Persona Cubierta</strong> ya no satisface los requisitos de Elegibilidad
          aqu&iacute; estipulados.</li>
      </ul>
      <p><strong>Miles Care by Novae, 601 Brickell Key Dr., Suite 501, Miami, FL 33131 EE. UU. Gestiona y promueve el
          motor de reservas de VIAJES, UN BENEFICIO DE BAC.</strong></p>
    </div>
  </div>
</div>